import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface Ticket {
    id: number;
    title: string;
    description: string;
    status: string;
    user_id: string;
    created_at: string;
    updated_at: string;
    resolved_at: string | null;
}

interface Pagination {
    limit: number;
    current_page: number;
    total_page: number;
    total_entity: number;
}

interface GetTicketsResponse {
    meta: {
        error: boolean;
        code: number;
        message: string;
    };
    data: Ticket[];
    pagination: Pagination;
}

type Props = {
    skip: number;
    limit: number;
    search?: string | null;
    status?: string | null;
    start_date?: string | null;
    end_date?: string | null;
};

export const getTickets = async (skip: number, limit: number, search?: string | null, status?: string | null, start_date?: string | null, end_date?: string | null) => {
    try {
        let url = `/tickets/?skip=${skip}&limit=${limit}`;
        if (search) {
            url += `&search=${search}`;
        }
        if (status && status !== "all") {
            url += `&status=${status}`;
        }
        if (start_date) {
            url += `&start_date=${start_date}`;
        }
        if (end_date) {
            url += `&end_date=${end_date}`;
        }
        const response = await Axios.get(url);
        return response.data as GetTicketsResponse;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetTickets = ({ skip, limit, search, status, start_date, end_date }: Props) => {
    const tickets = useQuery({
        queryKey: ["get-tickets", skip, limit, search, status, start_date, end_date],
        queryFn: () => getTickets(skip, limit, search, status, start_date, end_date),
    });

    return tickets;
};